import { motion } from "framer-motion"; // Import Framer Motion
import { Link } from "react-router-dom";
import TitleBar from "../../TitleBar/TitleBarWithoutDivider";
import TitleWithContent from "../../titlewithcontent(without divider)/TitleWithContentWithoutDivider";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import CustomLists from "@/components/elements/CustomLists/CustomLists";

// Shared entrance animation for each section.
const reveal = {
  variants: {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 },
  },
  transition: {
    duration: 0.5,
    ease: "easeOut",
    scale: { type: "spring", stiffness: 100, damping: 10 },
  },
} as const;

const CookiePolicy = () => {
  return (
    <div className="bg-custom-background pb-0 px-0 sm:px-1 2xl:px-40 xl:px-40 md:px-[3rem] ">
      <div className="pt-10">
        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          animate={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 0.5 }}
        >
          <TitleBar title="Cookie Policy" />
        </motion.div>
      </div>

      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { staggerChildren: 0.7, opacity: { duration: 0.5 } } },
        }}
      >
        <TitleWithContent title="Introduction">
          <motion.div {...reveal}>
            <Paragraph content="This Cookie Policy explains what Sheel Waterproofing Nepal Pvt. Ltd. stores on your device when you use our website, and why." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="What Are Cookies?">
          <motion.div {...reveal}>
            <Paragraph content="Cookies are small data files stored on your device. Websites can also use similar browser storage, such as local storage, to remember choices. This policy covers both." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="What We Store">
          <motion.div {...reveal}>
            <CustomLists
              layout="stacked"
              listStyle="disc"
              items={[
                [
                  "Necessary – your choice on the cookie banner, so we do not ask you again on every visit.",
                  "Optional (only if you accept) – the product category you last viewed, so we can show it again on your next visit.",
                  "Temporary – the filters you choose while browsing products and projects, and whether you have already seen our one-time welcome animation. These are cleared when you close the browser tab.",
                ],
              ]}
            />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="What We Do Not Use">
          <motion.div {...reveal}>
            <Paragraph content="We do not use analytics, advertising or tracking cookies, and this website does not set cookies of its own. If that changes, we will ask for your consent first and update this policy." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Third-Party Services">
          <motion.div {...reveal}>
            <Paragraph
              content={
                <>
                  Google Maps is the only third party that can set its own cookies through this website, and only if
                  you press “Show map” to load it; see Google’s privacy policy for what it stores. Other services we
                  use (our contact form, and where our content and images are delivered from) do not set cookies on
                  your device — see our{" "}
                  <Link to="/privacy-policy" className="text-custom-hov underline">
                    Privacy Policy
                  </Link>{" "}
                  for the full list of who we share data with and why.
                </>
              }
            />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Managing Your Choice">
          <motion.div {...reveal}>
            <Paragraph content="You can change your choice at any time with “Manage Cookies” in the footer, or clear stored data in your browser settings. The website works normally if your browser blocks storage." />
          </motion.div>
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default CookiePolicy;
